export default function initGraphAnimation() {
  circleChart();
}

// ============================================
// 円グラフ
// ============================================

function circleChart() {
  const targets = document.querySelectorAll(".acf-graph.-circle");

  if (!targets) {
    return;
  }

  targets.forEach((item) => {
    const draw = item.querySelector(".acf-graph__figure");
    const svg = draw.querySelector("svg");
    const svgPaths = draw.querySelectorAll("svg path");

    const reverseSvgPaths = Array.from(svgPaths).reverse();
    reverseSvgPaths.map((path) => {
      svg.appendChild(path);
    });
  });
}
